/*
  Member access: "SSO only" for a member; ops panel: Telegram alert topics.
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "This member can now sign in only through SSO": "Теперь участник входит только через SSO",
  "This member can sign in with a password again": "Участник снова может входить по паролю",
  "Could not change the sign-in method": "Не удалось изменить способ входа",
  "Sign-in:": "Вход:",
  "SSO only": "Только SSO",
  "Password or SSO": "Пароль или SSO",
  "Find topics": "Найти темы",
  "Could not load the topics": "Не удалось загрузить темы",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Бот не видел названий тем (режим приватности). Существующие номера тем:",
};

const es = {
  "This member can now sign in only through SSO": "Ahora este miembro solo puede entrar con SSO",
  "This member can sign in with a password again": "Este miembro puede volver a entrar con contraseña",
  "Could not change the sign-in method": "No se pudo cambiar el método de acceso",
  "Sign-in:": "Acceso:",
  "SSO only": "Solo SSO",
  "Password or SSO": "Contraseña o SSO",
  "Find topics": "Buscar temas",
  "Could not load the topics": "No se pudieron cargar los temas",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "El bot no ha visto nombres de temas (modo privacidad). IDs de temas que existen:",
};

const pt = {
  "This member can now sign in only through SSO": "Agora este membro só entra por SSO",
  "This member can sign in with a password again": "Este membro pode entrar com senha de novo",
  "Could not change the sign-in method": "Não foi possível mudar o método de acesso",
  "Sign-in:": "Acesso:",
  "SSO only": "Só SSO",
  "Password or SSO": "Senha ou SSO",
  "Find topics": "Buscar tópicos",
  "Could not load the topics": "Não foi possível carregar os tópicos",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "O bot não viu nomes de tópicos (modo privacidade). IDs de tópicos que existem:",
};

const de = {
  "This member can now sign in only through SSO": "Dieses Mitglied kann sich jetzt nur noch per SSO anmelden",
  "This member can sign in with a password again": "Dieses Mitglied kann sich wieder mit Passwort anmelden",
  "Could not change the sign-in method": "Die Anmeldeart konnte nicht geändert werden",
  "Sign-in:": "Anmeldung:",
  "SSO only": "Nur SSO",
  "Password or SSO": "Passwort oder SSO",
  "Find topics": "Themen finden",
  "Could not load the topics": "Die Themen konnten nicht geladen werden",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Der Bot hat keine Themennamen gesehen (Datenschutzmodus). Vorhandene Themen-IDs:",
};

const fr = {
  "This member can now sign in only through SSO": "Ce membre ne peut maintenant se connecter que par SSO",
  "This member can sign in with a password again": "Ce membre peut de nouveau se connecter avec un mot de passe",
  "Could not change the sign-in method": "Impossible de changer le mode de connexion",
  "Sign-in:": "Connexion :",
  "SSO only": "SSO uniquement",
  "Password or SSO": "Mot de passe ou SSO",
  "Find topics": "Trouver les sujets",
  "Could not load the topics": "Impossible de charger les sujets",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Le bot n’a vu aucun nom de sujet (mode confidentialité). Identifiants de sujets existants :",
};

const it = {
  "This member can now sign in only through SSO": "Ora questo membro può accedere solo tramite SSO",
  "This member can sign in with a password again": "Questo membro può di nuovo accedere con la password",
  "Could not change the sign-in method": "Impossibile cambiare il metodo di accesso",
  "Sign-in:": "Accesso:",
  "SSO only": "Solo SSO",
  "Password or SSO": "Password o SSO",
  "Find topics": "Trova argomenti",
  "Could not load the topics": "Impossibile caricare gli argomenti",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Il bot non ha visto nomi di argomenti (modalità privacy). ID degli argomenti esistenti:",
};

const pl = {
  "This member can now sign in only through SSO": "Ten członek może teraz logować się tylko przez SSO",
  "This member can sign in with a password again": "Ten członek znów może logować się hasłem",
  "Could not change the sign-in method": "Nie udało się zmienić sposobu logowania",
  "Sign-in:": "Logowanie:",
  "SSO only": "Tylko SSO",
  "Password or SSO": "Hasło lub SSO",
  "Find topics": "Znajdź tematy",
  "Could not load the topics": "Nie udało się wczytać tematów",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Bot nie widział nazw tematów (tryb prywatności). Istniejące numery tematów:",
};

const tr = {
  "This member can now sign in only through SSO": "Bu üye artık yalnızca SSO ile giriş yapabilir",
  "This member can sign in with a password again": "Bu üye yeniden parolayla giriş yapabilir",
  "Could not change the sign-in method": "Giriş yöntemi değiştirilemedi",
  "Sign-in:": "Giriş:",
  "SSO only": "Yalnızca SSO",
  "Password or SSO": "Parola veya SSO",
  "Find topics": "Konuları bul",
  "Could not load the topics": "Konular yüklenemedi",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Bot konu adlarını görmedi (gizlilik modu). Var olan konu numaraları:",
};

const uk = {
  "This member can now sign in only through SSO": "Тепер учасник входить лише через SSO",
  "This member can sign in with a password again": "Учасник знову може входити за паролем",
  "Could not change the sign-in method": "Не вдалося змінити спосіб входу",
  "Sign-in:": "Вхід:",
  "SSO only": "Лише SSO",
  "Password or SSO": "Пароль або SSO",
  "Find topics": "Знайти теми",
  "Could not load the topics": "Не вдалося завантажити теми",
  "The bot has not seen topic names (privacy mode). Topic ids that exist:": "Бот не бачив назв тем (режим приватності). Наявні номери тем:",
};

const MEMBER_SSO_TOPICS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default MEMBER_SSO_TOPICS;
